<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;
      Manage Branch</h5>
  </div>
<div id="mainContent" class="container">
  <div class="row pt-3">
    <div class="col-md-10 offset-md-1" style="">
      <button id="addBranchBtn" name="addBranchBtn" mat-raised-button class="btn-theme" style="float:right" matTooltip="Click to add branch" matTooltipPosition="left"
    (click)="openModal(modalContent,'add')">
        <i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;&nbsp; Branch
    </button>
    </div>
  </div>

  <div class="pt-2 pb-2">
    <div class="col-md-12">
      <table class="table table-striped table-bordered table-sm">
        <thead class="">
          <tr>
            <th scope="col">Sr.No.</th>
            <th scope="col">Name</th>
            <th scope="col">Address</th>
            <th scope="col">Contact No</th>
            <th scope="col" width="10%">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let modalFormObj of modalFormObjList; index as i" id="branch_{{i+1}}">
            <td scope="row">{{i+1}}</td>
            <td>{{modalFormObj.name}}</td>
            <td>{{modalFormObj.address}}</td>
            <td>{{modalFormObj.contactNo}}</td>
            <td width="10%">
              <button id="editBranchBtn_{{i+1}}" name="editBranchBtn_{{i+1}}" class="btn btn-sm btn-outline-theme"  (click)="onEditClick(modalContent,modalFormObj)"
              matTooltip="Click to edit" matTooltipPosition="above">
                <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
              </button> &nbsp;&nbsp;
              <button id="deleteBranchBtn_{{i+1}}" name="deleteBranchBtn_{{i+1}}" class="btn btn-sm btn-outline-danger" (click)="onDeleteClick(modalFormObj)"
              matTooltip="Click to delete" matTooltipPosition="above">
                <i class="fa fa-trash-o" aria-hidden="true"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>

  <!-- Modal Template -->
  <ng-template #modalContent let-modal>
    <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
      <h5 class="modal-title" id="modal-basic-title">Branch</h5>
    </div>
    <div class="modal-body">
      <form [formGroup]="modalForm">
        <div class="row">
        <label class="col-sm-4">Branch Name :</label>
        <div class="col-sm-8">
        <input id="name" name="name" type="text" class="form-control form-control-xs"
        formControlName="name" [class.is-invalid]="formErrors.name && formSubmitted" matTooltip="{{formErrors.name}}" matTooltipPosition="above">
        </div>
        </div>
        <div class="row mb-1">
        <label class="col-sm-4">Address :</label>
        <div class="col-sm-8">
        <textarea style="overflow:auto;resize:none" rows="3" cols="20" id="address" name="address" type="text" class="form-control form-control-xs"
        formControlName="address" [class.is-invalid]="formErrors.address && formSubmitted" matTooltip="{{formErrors.address}}" matTooltipPosition="above">
        </textarea>
        </div>
        </div>
        <div class="row">
        <label class="col-sm-4">Contact No :</label>
        <div class="col-sm-8">
        <input id="contactNo" name="contactNo" type="number" class="form-control form-control-xs"
        formControlName="contactNo" [class.is-invalid]="formErrors.contactNo && formSubmitted" matTooltip="{{formErrors.contactNo}}" matTooltipPosition="above">
        </div>
        </div>
        <div class="row">
        <label class="col-sm-4">Off Days :</label>
        <div class="col-sm-8">
        <mat-form-field appearance="legacy" style="width:300px;" matTooltip="{{formErrors.offDays}}" matTooltipPosition="above">
        <mat-select formControlName="offDays" multiple [compareWith]="compareItems">
        <!-- <mat-option [value]="1" (click)="selectAll(ev)" #ev >SelectAll</mat-option> -->
        <mat-option #item *ngFor="let offDay of offDaysList" [value]="offDay">{{offDay.name}}</mat-option>
        </mat-select>
        </mat-form-field>
        </div>
        </div>
      </form>
    </div>
    <div class="modal-footer" style="">
      <div class="row col-md-12">
          <div class="col-sm-6"></div>
          <div class="col-sm-3">
              <button id="closeBranchBtn" name="closeBranchBtn" type="button" class="btn btn-sm btn-block btn-outline-secondary" (click)="modal.dismiss('Cross click')">Close</button>
          </div>
          <div class="col-sm-3">
              <button id="saveBranchBtn" name="saveBranchBtn" type="button" *ngIf="modalStatus=='add'" class="btn btn-sm btn-block btn-outline-theme" (click)="onSaveClick()">Save</button>
              <button id="updateBranchBtn" name="updateBranchBtn" type="button" *ngIf="modalStatus=='edit'" class="btn btn-sm btn-block btn-outline-theme" (click)="onUpdateClick()">Update</button>
          </div>
      </div>
  </div>
  </ng-template>
